// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"358dbfc1","70":"ed285b9a","110":"d2c83cbc","239":"2361f268","276":"0947bfb3","353":"700fa49f","582":"b612b20e","612":"b802af6a","742":"6dceaabf","743":"afe9b3e8","807":"c74cfed1","818":"03a697e8","982":"a59bcd58"}[chunkId] + ".chunk.js";
};